import App from "@app/App";
import ReactDOM from "react-dom/client";
import AppProviders from "@app/providers/AppProviders";
import { registerSW } from "virtual:pwa-register";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <AppProviders>
    <App />
  </AppProviders>
);

// Register Service Worker
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  registerSW({ immediate: true });
}
